// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.azcoiner",
    name: "AZCoiner",
    homepage: "https://azcoiner.com/",
    image_id: "c6601184-7eb7-46c9-f6ad-0808cfd16100",
    app: {
        browser: null,
        ios: "https://apps.apple.com/vn/app/azcoiner/id6467728839?l=vi",
        android: "https://play.google.com/store/apps/details?id=com.azc.azcoiner&hl=vi-VN",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "azcoiner://",
        universal: "https://azcoiner.com/",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map